// extracted by mini-css-extract-plugin
module.exports = {"assigner":"RoleAssigner_assigner__1A3Kd","popover":"RoleAssigner_popover__lNKQS"};